import React, { useEffect, useState } from 'react';
import './Toast.css';

interface ToastProps {
  message: string;
  type?: 'success' | 'error' | 'info' | 'warning' | 'confirm';
  duration?: number;
  onClose?: () => void;
  position?: {
    top?: number;
    right?: number;
  };
  details?: string[];
  onConfirm?: () => void;
  onCancel?: () => void;
}

export const Toast: React.FC<ToastProps> = ({ 
  message, 
  type = 'info', 
  duration = 5000,
  onClose,
  position = { top: 20, right: 20 },
  details,
  onConfirm,
  onCancel
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLeaving, setIsLeaving] = useState(false);

  useEffect(() => {
    setIsVisible(true);

    // Solo configurar los temporizadores si no es un toast de confirmación
    if (type !== 'confirm') {
      const hideTimer = setTimeout(() => {
        setIsLeaving(true);
      }, duration - 300);

      const removeTimer = setTimeout(() => {
        setIsVisible(false);
        onClose?.();
      }, duration);

      return () => {
        clearTimeout(hideTimer);
        clearTimeout(removeTimer);
      };
    }
  }, [duration, onClose, type]);

  const handleConfirm = () => {
    setIsLeaving(true);
    setTimeout(() => {
      setIsVisible(false);
      onConfirm?.();
    }, 300);
  };

  const handleCancel = () => {
    setIsLeaving(true);
    setTimeout(() => {
      setIsVisible(false);
      onCancel?.();
    }, 300);
  };

  if (!isVisible) return null;

  const style = {
    top: `${position.top}px`,
    right: `${position.right}px`
  };

  return (
    <div 
      className={`toast ${type} ${isLeaving ? 'hide' : 'show'}`}
      style={style}
    >
      <div className="toast-content">{message}</div>
      {details && details.length > 0 && (
        <div className="toast-details">
          {details.map((detail, index) => (
            <div key={index}>{detail}</div>
          ))}
        </div>
      )}
      {type === 'confirm' && (
        <div className="toast-buttons">
          <button className="toast-button cancel" onClick={handleCancel}>
            Cancelar
          </button>
          <button 
            className="toast-button confirm" 
            onClick={handleConfirm}
            data-tutorial-target="confirm-delete-button"
          >
            Confirmar
          </button>
        </div>
      )}
    </div>
  );
}; 